import React, { Component } from "react";
import { Router, Switch, Route } from "react-router-dom";

import "assets/scss/material-kit-react.scss?v=1.8.0";
import "./routes.css";

// pages for this product
import PGDash from "views/PGDash/PGDash.js";
import LandingPage from "views/LandingPage/LandingPage.js";
import Manager from "views/Manager/Manager.js";
import LoginPage from "views/LoginPage/LoginPage.js";
import AboutPage from "views/AboutPage/AboutPage.js";
import Download from "views/Download/Download";
import ContactPage from "views/ContactPage/ContactPage.js";
import PrivacyPage from "views/PrivacyPage/PrivacyPage.js";
import PrivacyThirdPartyDisclosure from "views/PrivacyThirdPartyDisclosure/PrivacyThirdPartyDisclosure.js";
import ListResult from "views/SearchResultPages/ListResult.js";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import MuiButton from "@material-ui/core/Button";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CloseIcon from "@material-ui/icons/Close";
import { createBrowserHistory } from "history";
import api from "utils/api";
import Button from "components/CustomButtons/Button.js";

const hist = createBrowserHistory();

export default class Routes extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLodading: false,
            user: false,
            userZip: null,
            searchObj: '',
            showTimeOutW: false,
            sessionCounter: 0,
            autoLogOutCounter: 0,
            showConsentPopup: false,
            showConsentPreferencesDialog: false,
            consentPreferences: this.getDefaultConsentPreference(),
            draftConsentPreferences: this.getDefaultConsentPreference()
        };
    }

    consentStorageKey = "ffConsentPreference";
    analyticsMeasurementId = "G-N5JDC2MGS2";
    unlistenHistory = null;

    componentDidMount() {
        this.applyConsentPreference(this.readStoredConsentPreference());
        this.setConsentPopupForPath(hist.location.pathname);
        this.unlistenHistory = hist.listen((location) => {
            this.setConsentPopupForPath(location.pathname);
        });
    }

    componentWillUnmount() {
        if (this.unlistenHistory) {
            this.unlistenHistory();
        }
    }

    getDefaultConsentPreference = () => ({
        requiredCookies: true,
        allowAllCookies: true,
        analyticsTracking: true
    });

    normalizeConsentPreference = (value) => {
        if (value === "accepted") {
            return {
                requiredCookies: true,
                allowAllCookies: true,
                analyticsTracking: true
            };
        }

        if (value === "opted-out" || !value) {
            return this.getDefaultConsentPreference();
        }

        return {
            requiredCookies: true,
            allowAllCookies: !!value.allowAllCookies,
            analyticsTracking: !!value.analyticsTracking
        };
    }

    readStoredConsentPreference = () => {
        if (!window.localStorage) {
            return null;
        }

        const raw = localStorage.getItem(this.consentStorageKey);
        if (!raw) {
            return null;
        }

        if (raw === "accepted" || raw === "opted-out") {
            return this.normalizeConsentPreference(raw);
        }

        try {
            return this.normalizeConsentPreference(JSON.parse(raw));
        } catch {
            return null;
        }
    }

    saveConsentPreference = (preference) => {
        const normalized = this.normalizeConsentPreference(preference);
        const payload = {
            ...normalized,
            savedAt: new Date().toISOString()
        };

        localStorage.setItem(this.consentStorageKey, JSON.stringify(payload));
        this.applyConsentPreference(payload);
        this.setState({
            showConsentPopup: false,
            showConsentPreferencesDialog: false
        });
    }

    applyConsentPreference = (preference) => {
        const normalized = this.normalizeConsentPreference(preference);
        this.setAnalyticsEnabled(normalized.analyticsTracking);
        this.setState({
            consentPreferences: { ...normalized },
            draftConsentPreferences: { ...normalized }
        });
    }

    setAnalyticsEnabled = (enabled) => {
        window[`ga-disable-${this.analyticsMeasurementId}`] = !enabled;
    }

    setConsentPopupForPath = (pathname) => {
        const hasPreference = !!localStorage.getItem(this.consentStorageKey);
        this.setState({
            showConsentPopup: pathname === "/" && !hasPreference
        });
    }

    acceptConsent = () => {
        this.saveConsentPreference({
            requiredCookies: true,
            allowAllCookies: true,
            analyticsTracking: true
        });
    }

    openConsentPreferencesDialog = () => {
        const storedPreference = this.readStoredConsentPreference();
        this.setState({
            draftConsentPreferences: {
                ...(storedPreference ? storedPreference : this.getDefaultConsentPreference())
            },
            showConsentPreferencesDialog: true
        });
    }

    closeConsentPopup = () => {
        this.setState({ showConsentPopup: false });
    }

    closeConsentPreferencesDialog = () => {
        this.setState({ showConsentPreferencesDialog: false });
    }

    saveConsentDialogPreferences = () => {
        const allowAllCookies = !!this.state.draftConsentPreferences.allowAllCookies;
        this.saveConsentPreference({
            requiredCookies: true,
            allowAllCookies,
            analyticsTracking: allowAllCookies
        });
    }

    allowAllCookies = () => {
        this.saveConsentPreference({
            requiredCookies: true,
            allowAllCookies: true,
            analyticsTracking: true
        });
    }

    onCookiePreferenceChange = (event) => {
        const allowAllCookies = event.target.value === "true";
        this.setState({
            draftConsentPreferences: {
                requiredCookies: true,
                allowAllCookies,
                analyticsTracking: allowAllCookies
            }
        });
    }

    navigateToPrivacyDisclosure = () => {
        this.setState({ showConsentPopup: false });
        hist.push("/privacy-3rd-party-disclosure");
    }

    navigateToContact = () => {
        this.setState({ showConsentPopup: false });
        window.location.href = "https://forms.gle/RYb4veiWnCs4i4Aw6";
    }

    setUser = (u) => {
        console.log("route setUser: ", u);
        this.setState({ user: u });
    }

    setUserZip = (zip) => {
        console.log("route setUserZip: ", zip)
        this.setState({ userZip: zip });
    }

    setSearchObj = (obj) => {
        console.log("route setSearchObj: ", obj);
        if (!obj.SourceZipCode) {
            obj.SourceZipCode = this.state.userZip;
        }
        this.setState({ searchObj: obj });
    }

    setSessionCounter = (t) => {
        this.setState({ sessionCounter: t});
    }

    autoLogOutInterval = null;

    showTimeOutWarning = () => {
        this.setState({ showTimeOutW: true }, () => {
            this.autoLogOutInterval = setInterval(()=> {
                var newAutoLogO = this.state.autoLogOutCounter + 60000;
                this.setState({ autoLogOutCounter: newAutoLogO });
                if(newAutoLogO > 5*60000){ // after 5min
                    this.setState({ showTimeOutW: false });
                    this.setUser(null);
                    api.logout();
                }
            }, 60000)
        });
    }

    handleTimeOut = async (extended) => {
        if(extended){
            clearInterval(this.autoLogOutInterval);
            var isExtended = await api.extendUserSession();
            if(isExtended){
                this.setState({ showTimeOutW: false });
                this.setSessionCounter(0);
            } else {
                this.setUser(null);
                api.logout();
                this.setState({ showTimeOutW: false });
            }
        } else {
            this.setState({ showTimeOutW: false });
            this.setUser(null);
            api.logout();
        }
    }

    render() {
        return (
            <Router history={hist}>
                <Switch>
                    <Route exact path="/Manager" render={() => (<Manager sessionCounter={this.state.sessionCounter} setSessionCounter={(t) => this.setSessionCounter(t)} showTimeOutWarning={() => this.showTimeOutWarning()} user={this.state.user} setUser={(user) => this.setUser(user)} type={'manager'} userZip={this.state.userZip} setUserZip={(zip) => this.setUserZip(zip)} />)} />
                    <Route exact path="/login" render={() => (<LoginPage user={this.state.user} setUser={(user) => this.setUser(user)} userZip={this.state.userZip} setUserZip={(zip) => this.setUserZip(zip)} />)} />
                    <Route exact path="/admin" render={() => (<PGDash sessionCounter={this.state.sessionCounter} setSessionCounter={(t) => this.setSessionCounter(t)} showTimeOutWarning={() => this.showTimeOutWarning()} user={this.state.user} setUser={(user) => this.setUser(user)} userZip={this.state.userZip} setUserZip={(zip) => this.setUserZip(zip)} />)} />
                    <Route exact path='/about' render={() => (<AboutPage user={this.state.user} setUser={(user) => this.setState(user)} userZip={this.state.userZip} setUserZip={(zip) => this.setUserZip(zip)} />)} />
                    <Route exact path='/contact' render={() => (<ContactPage user={this.state.user} setUser={(user) => this.setState(user)} userZip={this.state.userZip} setUserZip={(zip) => this.setUserZip(zip)}/>)}/>
                    <Route exact path='/terms' render={() => (<PrivacyPage user={this.state.user} setUser={(user) => this.setState(user)} userZip={this.state.userZip} setUserZip={(zip) => this.setUserZip(zip)} />)} />
                    <Route exact path='/privacy-3rd-party-disclosure' render={() => (<PrivacyThirdPartyDisclosure />)} />
                    <Route path="/search/:merchantID/:promotionID" render={(props) => {
                        return <ListResult routeParams={props.match.params} user={this.state.user} setUser={(user) => this.setUser(user)} userZip={this.state.userZip} setUserZip={(zip) => this.setUserZip(zip)} searchObj={this.state.searchObj} setSearchObj={(o) => this.setSearchObj(o)} />
                    }} />
                    <Route exact path='/download' render={() => (<Download user={this.state.user} setUser={(user) => this.setState(user)} userZip={this.state.userZip} setUserZip={(zip) => this.setUserZip(zip)} />)} />
                    <Route path="/" render={() => (<LandingPage user={this.state.user} setUser={(user) => this.setUser(user)} userZip={this.state.userZip} setUserZip={(zip) => this.setUserZip(zip)} searchObj={this.state.searchObj} setSearchObj={(o) => this.setSearchObj(o)} />)} />
                </Switch>
                {/* TimeOut */}
                <Dialog
                    open={this.state.showTimeOutW}
                    // TransitionComponent={Transition}
                    onClose={this.handleHideLogin} >
                    <DialogTitle>
                        Session Time Out
                    </DialogTitle>
                    <DialogContent>
                        <span>
                            You have been inactive for the past 45min. You will be logged out.
                            <br />
                            Need more time?
                        </span>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" onClick={() => this.handleTimeOut(true)}>Yes</Button>
                        <Button color="warning" onClick={() => this.handleTimeOut(false)}>No</Button>
                    </DialogActions>
                </Dialog>
                {this.state.showConsentPopup ? (
                    <div className="consent-popup">
                        <IconButton className="consent-close" aria-label="Close consent popup" onClick={this.closeConsentPopup}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                        <div className="consent-title">Manage Consent</div>
                        <p>
                            To provide the best experiences, we use technologies like cookies to store and/or access
                            device information. Consenting to these technologies will allow us to process data such as
                            browsing behavior or unique IDs on this site. Analytics and other optional technologies
                            remain off until you choose to enable them. Not consenting or withdrawing consent may
                            adversely affect certain features and functions.
                        </p>
                        <MuiButton variant="contained" color="primary" className="consent-accept" onClick={this.acceptConsent}>
                            Accept
                        </MuiButton>
                        <div className="consent-links">
                            <button type="button" className="consent-link" onClick={this.openConsentPreferencesDialog}>
                                Opt-out preferences
                            </button>
                            <button type="button" className="consent-link" onClick={this.navigateToPrivacyDisclosure}>
                                Privacy Policy
                            </button>
                            <button type="button" className="consent-link" onClick={this.navigateToContact}>
                                Contact Us
                            </button>
                        </div>
                    </div>
                ) : null}
                <Dialog
                    open={this.state.showConsentPreferencesDialog}
                    onClose={this.closeConsentPreferencesDialog}
                    maxWidth="sm"
                    fullWidth
                    PaperProps={{ className: "consent-dialog-paper" }}
                    aria-labelledby="consent-preferences-title">
                    <DialogTitle id="consent-preferences-title" className="consent-dialog-title">
                        Cookie Preferences
                    </DialogTitle>
                    <DialogContent className="consent-dialog-content">
                        <p className="consent-dialog-copy">
                            Some services are required for this website to function, including security, session
                            management, account access, and location search support. These required cookies cannot be
                            turned off.
                        </p>

                        <div className="consent-setting-card consent-setting-card--locked">
                            <div>
                                <div className="consent-setting-title">Required Cookies (Always active)</div>
                                <div className="consent-setting-copy">
                                    Needed for login/session continuity, Firebase, Google Cloud, security, and required
                                    application features.
                                </div>
                            </div>
                        </div>

                        <div className="consent-setting-card">
                            <div>
                                <div className="consent-setting-title">Cookie Preference</div>
                                <div className="consent-setting-copy">
                                    Choose whether to save only the required cookies or allow optional cookies and
                                    activity tracking.
                                </div>
                                <div className="consent-setting-copy">
                                    When you allow all cookies, optional analytics may collect page activity and usage
                                    data. Choosing required cookies keeps optional analytics tracking off.
                                </div>
                            </div>
                            <RadioGroup
                                className="consent-radio-group"
                                value={String(this.state.draftConsentPreferences.allowAllCookies)}
                                onChange={this.onCookiePreferenceChange}>
                                <FormControlLabel value="true" control={<Radio color="primary" />} label="Allow All Cookies" />
                                <FormControlLabel value="false" control={<Radio color="primary" />} label="Allow Required Cookies only" />
                            </RadioGroup>
                        </div>

                        <div className="consent-setting-card consent-setting-card--info">
                            <div>
                                <div className="consent-setting-title">Other Optional Services</div>
                                <div className="consent-setting-copy">
                                    Google Maps, browser location, and social sharing features may use cookies or
                                    similar technologies when you choose to use those services.
                                </div>
                            </div>
                        </div>

                        <p className="consent-dialog-note">
                            More detail is available in our{" "}
                            <button type="button" className="consent-link consent-inline-link" onClick={this.navigateToPrivacyDisclosure}>
                                Third-Party Services &amp; Privacy Disclosure
                            </button>
                            .
                        </p>
                    </DialogContent>
                    <DialogActions className="consent-dialog-actions">
                        <MuiButton variant="outlined" type="button" onClick={this.saveConsentDialogPreferences}>
                            Save preferences
                        </MuiButton>
                        <MuiButton variant="contained" color="primary" type="button" onClick={this.allowAllCookies}>
                            Allow All
                        </MuiButton>
                    </DialogActions>
                </Dialog>
            </Router>
        )
    }
}
